import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /auto-search was merged into the Prospection hub as its "Résultats
 * automatiques" tab. Keep the URL alive with a permanent redirect.
 */
export const Route = createFileRoute("/_app/auto-search")({
  beforeLoad: () => {
    throw redirect({ to: "/search", search: { tab: "auto" } as any, replace: true });
  },
});
